import React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useEffect } from 'react';
import FormHelperText from '@mui/material/FormHelperText';


function TerugleveringInput({ returnedEnergyAmount, setReturnedEnergyAmount, dubbeleMeter }) {

  const [terugleveringHoogError, setTerugleveringHoogError] = useState(false);
  const [terugleveringLaagError, setTerugleveringLaagError] = useState(false);


  const handleChange = (field, value) => {
    const newValue = value.trim();
    const re = /^[0-9\b]+$/;
    // If value is empty or passes the regex test, update the state
    if (newValue === "" || re.test(newValue)) {
      setReturnedEnergyAmount((prevState) => ({
        ...prevState,
        [field]: value.trim() === '' ? null : value,
      }));
    }
  };

  const handleOnBlur = (field, value) => {

    // if empty
    if (value === "") {
      if (field == "return_high") {
        setTerugleveringHoogError(true);
      }
      if (field == "return_low") {
        setTerugleveringLaagError(true);
      }
    } else {
      if (field == "return_high") {
        setTerugleveringHoogError(false);
      }
      if (field == "return_low") {
        setTerugleveringLaagError(false);
      }
    }
  };

  useEffect(() => {
    // This code will run on mount and whenever `returnedEnergyAmount` changes
    // Check if returnedEnergyAmount exists and has the properties return_high and return_low
    // If not, set them to null
    if (dubbeleMeter) {
      if (!returnedEnergyAmount || !returnedEnergyAmount.return_high || !returnedEnergyAmount.return_low) {
        setReturnedEnergyAmount(prevState => ({
          ...prevState,
          return_high: prevState?.return_high !== undefined ? prevState.return_high : null,
          // Update 'return_low' naar null alleen als het nog niet gedefinieerd is
          return_low: prevState?.return_low !== undefined ? prevState.return_low : null,
        }));
      }
    } else {
      if (!returnedEnergyAmount || !returnedEnergyAmount.return) {
        setReturnedEnergyAmount(prevState => ({
          ...prevState,
          return: null
        }));
      }
    }
  }, []); // An empty dependencies array ensures this effect only runs once on mount


  return (
    <div class="teruglevering-container">
      {/* <ComponentHeaderTitles title="Teruglevering per jaar" /> */}
      {dubbeleMeter ? (
        <>
          <div className="teruglevering-hoog">
            <FormControl variant="outlined">
              <Typography variant="caption" color="textSecondary">
                Teruglevering hoog (per jaar)
              </Typography>
              <OutlinedInput
                type="text"
                id="outlined-adornment-weight"
                placeholder="0000"
                endAdornment={<InputAdornment position="end">kWh</InputAdornment>}
                startAdornment={
                  <InputAdornment position="start">
                    <span className="icon-as-stroomlicht icon-size" />
                  </InputAdornment>
                }
                aria-describedby="outlined-weight-helper-text"
                className="verbruik-input"
                inputProps={{
                  'aria-label': 'weight',
                  inputMode: "numeric"
                }}
                value={returnedEnergyAmount && returnedEnergyAmount.return_high ? returnedEnergyAmount.return_high : ''}
                onBlur={(e) => handleOnBlur('return_high', e.target.value)}
                error={terugleveringHoogError}
                onChange={(e) => handleChange('return_high', e.target.value)}
              />
              {terugleveringHoogError && (
                <FormHelperText error={terugleveringHoogError}>
                  Gelieve je je hoog stroomverbruik teruglevering in te vullen. Lever je geen hoog stroom terug? Vul dan 0 in.
                </FormHelperText>
              )}

            </FormControl>
          </div>
          <div class="teruglevering-laag">
            <FormControl variant="outlined">
              <Typography variant="caption" color="textSecondary">
                Teruglevering laag (per jaar)
              </Typography>
              <OutlinedInput
                type="text"
                id="outlined-adornment-weight"
                endAdornment={<InputAdornment position="end">kWh</InputAdornment>}
                aria-describedby="outlined-weight-helper-text"
                placeholder="0000"
                startAdornment={
                  <InputAdornment position="start">
                    <span className="icon-as-stroomlicht icon-size" />
                  </InputAdornment>
                }
                className="verbruik-input"
                inputProps={{
                  'aria-label': 'weight',
                  inputMode: "numeric"
                }}
                value={returnedEnergyAmount && returnedEnergyAmount.return_low ? returnedEnergyAmount.return_low : ''}
                onBlur={(e) => handleOnBlur('return_low', e.target.value)}
                error={terugleveringLaagError}
                onChange={(e) => handleChange('return_low', e.target.value)}
              />
              {terugleveringLaagError && (
                <FormHelperText error={terugleveringLaagError}>
                  Gelieve je je laag stroomverbruik teruglevering in te vullen. Lever je geen laag stroom terug? Vul dan 0 in.
                </FormHelperText>
              )}
            </FormControl>
          </div>
        </>
      ) : (
        <div class="teruglevering-normaal">
          <FormControl variant="outlined">
            <Typography variant="caption" color="textSecondary">
              Teruglevering (per jaar)
            </Typography>
            <OutlinedInput
              type="text"
              id="outlined-adornment-weight"
              endAdornment={<InputAdornment position="end">kWh</InputAdornment>}
              aria-describedby="outlined-weight-helper-text"
              placeholder="0000"
              startAdornment={
                <InputAdornment position="start">
                  <span className="icon-as-stroomlicht icon-size" />
                </InputAdornment>
              }
              className="verbruik-input"
              inputProps={{
                'aria-label': 'weight',
                inputMode: "numeric"
              }}
              value={returnedEnergyAmount && returnedEnergyAmount.return ? returnedEnergyAmount.return : ''}
              onBlur={(e) => handleOnBlur('return', e.target.value)}
              error={terugleveringLaagError}
              onChange={(e) => handleChange('return', e.target.value)}
            />
            {terugleveringLaagError && (
              <FormHelperText error={terugleveringLaagError}>
                Gelieve je stroomverbruik teruglevering in te vullen. Lever je geen laag stroom terug? Vul dan 0 in.
              </FormHelperText>
            )}
          </FormControl>
        </div>
      )
      }


    </div>

  )
}

TerugleveringInput.displayName = 'TerugleveringInput';
export default TerugleveringInput;
